import { BaseSortVisitor } from './baseSort.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { ParsePlainObject } from '../plainObjects/parse.plainObject';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ParseVisitor extends BaseSortVisitor {
    private get _parseTransformation(): ParsePlainObject {
        return this.transformation as ParsePlainObject;
    }

    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const parseColumn = new ExpressionColumnPlainObject();
        parseColumn.name = SchemaUtil.getColumnName(assignment.columnIdentifier());
        if (assignment.expression()) {
            parseColumn.expression = this._getText(assignment.expression().left);
            parseColumn.typeExpression = this._getText(assignment.expression().right);
        }
        this._parseTransformation.columns.push(parseColumn);
        return parseColumn;
    }

    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'each') {
            MatchFunctionUtil.addColumnPatternColumns(this._parseTransformation, this._tokenStream, context);
        }
    }
}
